import { createFileRoute } from '@tanstack/react-router'
import { WebhooksPage } from '@/features/webhooks/pages/WebhooksPage'

export const Route = createFileRoute('/_app/webhooks/')({
  component: WebhooksPage,
})
